/**
 * Classe base para a formatação de dados do tipo checkbox.
 * @author: Adalto Junior
 * Date: 20/08/2014
 */

Monet.Format = Monet.Format || {};
Monet.Format.CHECKBOX = (function () {

    function CHECKBOX(value, dataContext, entity, field){

        Monet.Format.Base.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {
            switch (field) {
                case 'stop.hasSignature':
                    this.value = Monet.FormBuilder.CreateIconHasSignature(this.value, dataContext, entity);
                    break;
                case 'route.hasPicture':
                case 'stop.hasPicture':
                    this.value = Monet.FormBuilder.CreateIconHasPicture(this.value, dataContext, entity);
                    break;
                case 'hasSurveyApplied':
                    this.value = Monet.FormBuilder.CreateIconHasSurveyApplied(this.value, dataContext, entity);
                    break;
                case 'route.unsuccessfulDelivery':
                    this.value = Monet.FormBuilder.CreateIconUnsuccessfulDelivery(this.value, dataContext);
                    break;
                default:
                    this.value = `<div class="gridCheckbox${this.value ? 'True' : 'False'}"></div>`;
            }

            return this;
        };

    }

    return CHECKBOX;
}());